import { render } from "./RejectedPayments.vue?vue&type=template&id=03c41b7f"
import script from "./RejectedPayments.vue?vue&type=script&lang=js"
export * from "./RejectedPayments.vue?vue&type=script&lang=js"

import "./RejectedPayments.vue?vue&type=style&index=0&id=03c41b7f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__